/**
 * Created by Jerker Nord on 2019-03-12.
 */

// imported this file from Thor Game for betline animations.
// modified by Pradeep Kumar

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {AnimatedMeshRope} from "../../bezieranimation/AnimatedMeshRope";
import {TimelineLite} from "gsap";
import {TextureHelper} from "../../bezieranimation/TextureHelper";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";
import {TombOfNefertitiHelper} from "../../utils/TombOfNefertitiHelper";

export class TombOfNefertitiAnimatedWinlinesView extends BaseView {

    private _layer: ScalableLayer;
    private _winLines: AnimatedMeshRope[];
    private _winLinesAdded: number[];
    private _fixedTextures: PIXI.Texture[];
    private _initAnimations: boolean = false;

    private _currNumber: number = -1;

    constructor() {
        super();
        this._layer = StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.BET_LINES.name);
        this._layer.addChild(this);
        this._winLines = [];
        this._winLinesAdded = [];
    }

    private _betLinesData: number[][];

    set betLinesData(value: number[][]) {
        this._betLinesData = value;
        if (this._initAnimations && this._winLines.length == 0) {
            this.createWinLines();
        }
    }

    public getWinlineTL(winLine: number, isStaticOrIsIdle: boolean, canIndividualLoop: boolean, isCalledFromIndividual: boolean, isCalledFromFSIntro?: boolean): TimelineLite {
        const winLineTL: TimelineLite = new TimelineLite({});

        if (this._winLinesAdded.indexOf(winLine) == -1) {
            this._winLinesAdded.push(winLine);
            winLineTL.add(() => (this.addChild(this._winLines[winLine])));
        }

        if (isCalledFromIndividual) {
            if (this._currNumber !== winLine) {
                winLineTL.add(() => (this._winLines[winLine].getAnimatedMeshRopeTLIdle(canIndividualLoop, isStaticOrIsIdle, isCalledFromFSIntro)));
            }
            this._currNumber = winLine;
        } else {
            winLineTL.add(() => (this._winLines[winLine].getAnimatedMeshRopeTL(isStaticOrIsIdle)));
        }

        return winLineTL;
    }

    public getCleanUpWinlinesTL(): TimelineLite {
        const cleanUpWinLinesTL: TimelineLite = new TimelineLite({});

        cleanUpWinLinesTL.add(() => (this.removeChildren()));
        cleanUpWinLinesTL.add(() => (this._winLinesAdded = []));
        cleanUpWinLinesTL.add(() => this._currNumber = -1);

        return cleanUpWinLinesTL;
    }

    protected initAnimations(): void {
        this._initAnimations = true;
        this._fixedTextures = TextureHelper.removeBaseTextures(GameResources.getTextures("winEnergy"));
        if (this._betLinesData) {
            this.createWinLines();
        }
    }

    private createWinLines(): void {
        for (let i: number = 0; i < this._betLinesData.length; i++) {
            let curvePoints: number[][] = [];
            for (let j: number = 0; j < this._betLinesData[i].length; j++) {
                curvePoints.push(TombOfNefertitiHelper.getSymbolPositions(j, this._betLinesData[i][j]));
            }
            this.createWinLine(curvePoints);
        }
    }

    private createWinLine(curvePoints: number[][]): void {
        const animatedMeshRope: AnimatedMeshRope = new AnimatedMeshRope();
        animatedMeshRope.createAnimatedMeshRope(this._fixedTextures, curvePoints);
        this._winLines.push(animatedMeshRope);
    }
}